import { Component } from '@angular/core';
import { SHARED_STANDALONE_IMPORTS } from 'app/shared/standalone-imports';

@Component({
  selector: 'app-menu-content',
  templateUrl: './menu-content.component.html',
  styleUrls: ['./menu-content.component.scss'],
  standalone: true,
  imports: [...SHARED_STANDALONE_IMPORTS],
})
export class MenuContentComponent {}
